<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="astral-content-width" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['name']"></astral-input>
          <astral-checkbox [control]="form.controls['isRent']" [helpText]="'ARTICLE_GROUP.HELP_TEXT.IS_RENT'"></astral-checkbox>
        </astral-layout-group>
      </section>
    </form>
  }
</section>
